class ProfessionalLoginGateway extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-professional-login-dialog]');
    this.emailForm = this.querySelector('[data-professional-login-email-form]');

    if (!(this.dialog instanceof HTMLDialogElement)) return;

    document.addEventListener('click', this.handleTriggerClick);
    this.querySelectorAll('[data-professional-login-close]').forEach((button) => {
      button.addEventListener('click', this.close);
    });
    this.dialog.addEventListener('cancel', this.handleCancel);
    this.dialog.addEventListener('click', this.handleBackdropClick);
    this.dialog.addEventListener('close', this.restorePageScroll);
    this.emailForm?.addEventListener('submit', this.handleEmailSubmit);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleTriggerClick);
    this.emailForm?.removeEventListener('submit', this.handleEmailSubmit);
    this.restorePageScroll();
  }

  handleTriggerClick = (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-professional-login-open]') : null;

    if (!(trigger instanceof HTMLAnchorElement)) return;

    event.preventDefault();
    const registrationPopup = trigger.closest('professional-registration-popup');
    const registrationDialog = registrationPopup?.querySelector('[data-registration-dialog]');

    if (registrationDialog instanceof HTMLDialogElement && registrationDialog.open) {
      const previousBodyOverflow =
        typeof registrationPopup.previousBodyOverflow === 'string' ? registrationPopup.previousBodyOverflow : '';

      registrationDialog.addEventListener(
        'close',
        () => {
          document.body.style.overflow = 'hidden';
        },
        { once: true }
      );

      this.open(previousBodyOverflow);
      registrationDialog.close();
      document.body.style.overflow = 'hidden';
      return;
    }

    this.open();
  };

  open = (previousBodyOverflow) => {
    if (!(this.dialog instanceof HTMLDialogElement) || this.dialog.open) return;

    this.previousBodyOverflow =
      typeof previousBodyOverflow === 'string' ? previousBodyOverflow : document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    this.dialog.showModal();
  };

  close = () => {
    if (this.dialog instanceof HTMLDialogElement && this.dialog.open) {
      this.dialog.close();
    }
  };

  handleEmailSubmit = (event) => {
    if (!(event.currentTarget instanceof HTMLFormElement)) return;

    event.preventDefault();
    const form = event.currentTarget;
    const emailInput = form.querySelector('[data-professional-login-email]');
    const loginUrl = form.dataset.loginUrl;

    if (!(emailInput instanceof HTMLInputElement) || !loginUrl) return;

    emailInput.value = emailInput.value.trim();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const destination = new URL(loginUrl, window.location.origin);
    destination.searchParams.set('login_hint', emailInput.value);
    window.location.assign(destination.href);
  };

  handleCancel = (event) => {
    event.preventDefault();
    this.close();
  };

  handleBackdropClick = (event) => {
    if (event.target === this.dialog) {
      this.close();
    }
  };

  restorePageScroll = () => {
    document.body.style.overflow = this.previousBodyOverflow || '';
  };
}

if (!customElements.get('professional-login-gateway')) {
  customElements.define('professional-login-gateway', ProfessionalLoginGateway);
}
